import { render, staticRenderFns } from "./ArticuloConfiguracionComponent.vue?vue&type=template&id=37b976a4"
import script from "./ArticuloConfiguracionComponent.vue?vue&type=script&lang=js"
export * from "./ArticuloConfiguracionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports